import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './TermsAndConditions.css';

/**
 * TermsAndConditions component - Displays the terms and conditions using Termly embed
 * @returns {JSX.Element} The rendered terms and conditions page with Termly iframe
 */
const TermsAndConditions = () => {
  const navigate = useNavigate();

  /**
   * Loads the Termly embed script when component mounts
   */
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';

    const existingScript = document.getElementById('termly-jssdk');
    if (!existingScript) {
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    return () => {
      const scriptToRemove = document.getElementById('termly-jssdk');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  /**
   * Handles navigation back to previous page or home
   * @returns {void}
   */
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="terms-and-conditions-container">
      <div className="terms-and-conditions-header">
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft />
        </button>
        <h1>Terms and Conditions</h1>
      </div>
      <div className="terms-and-conditions-content">
        <div name="termly-embed" data-id="e44a5f3b-48da-489c-b9bc-d1e50eed7a35"></div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
